// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.thank-you-dialog {
  width: 100%;
  max-width: 500px;
  min-width: 400px;
  padding: 0;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 22px;
  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35);
  overflow: hidden;
}
.thank-you-dialog .dialog-header {
  display: flex;
  justify-content: flex-end;
  padding: 20px 24px 0 24px;
  background: #ffffff;
  border-top-left-radius: 22px;
  border-top-right-radius: 22px;
}
.thank-you-dialog .dialog-header .close-button {
  color: #666;
}
.thank-you-dialog .dialog-content {
  padding: 32px 24px;
  text-align: center;
}
.thank-you-dialog .dialog-content .icon-container {
  margin-bottom: 20px;
}
.thank-you-dialog .dialog-content .icon-container .thank-you-icon {
  font-size: 64px;
  width: 64px;
  height: 64px;
  color: #e91e63;
}
.thank-you-dialog .dialog-content h2 {
  margin: 0 0 12px 0;
  font-size: 24px;
  color: #333;
}
.thank-you-dialog .dialog-content p {
  margin: 0 0 8px 0;
  color: #666;
  font-size: 14px;
  line-height: 1.5;
}
.thank-you-dialog .dialog-content .sub-text {
  color: #999;
  font-size: 13px;
}
.thank-you-dialog .dialog-content .comment-encouragement {
  margin: 16px 0 0 0;
  color: #666;
  font-size: 14px;
  line-height: 1.5;
}
.thank-you-dialog .dialog-content .comment-link {
  color: #e91e63;
  text-decoration: none;
  cursor: pointer;
  font-weight: 500;
  transition: color 0.2s ease;
}
.thank-you-dialog .dialog-content .comment-link:hover {
  color: #c2185b;
  text-decoration: underline;
}
.thank-you-dialog .dialog-content .comment-link:active {
  color: #ad1457;
}

@media (max-width: 640px) {
  .thank-you-dialog {
    width: 100%;
    max-width: 100%;
    min-width: auto;
    border-radius: 16px;
  }
  .thank-you-dialog .dialog-header {
    padding: 16px 16px 0 16px;
  }
  .thank-you-dialog .dialog-content {
    padding: 24px 16px;
  }
}
:host-context(body.theme-dark) .thank-you-dialog,
:host-context(body.theme-dark) .thank-you-dialog .dialog-header,
:host-context(body.theme-dark) .thank-you-dialog .dialog-content {
  background: #111827 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .thank-you-dialog h2,
:host-context(body.theme-dark) .thank-you-dialog p,
:host-context(body.theme-dark) .thank-you-dialog .sub-text,
:host-context(body.theme-dark) .thank-you-dialog .comment-encouragement,
:host-context(body.theme-dark) .thank-you-dialog .close-button,
:host-context(body.theme-dark) .thank-you-dialog .close-button mat-icon {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .thank-you-dialog .comment-link {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .thank-you-dialog .comment-link:hover {
  color: #bfdbfe !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/flow-thank-you/flow-thank-you.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,4CAAA;EACA,gBAAA;AACF;AACE;EACE,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,4BAAA;EACA,6BAAA;AACJ;AACI;EACE,WAAA;AACN;AAGE;EACE,kBAAA;EACA,kBAAA;AADJ;AAGI;EACE,mBAAA;AADN;AAGM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AADR;AAKI;EACE,kBAAA;EACA,eAAA;EACA,WAAA;AAHN;AAMI;EACE,iBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAJN;AAOI;EACE,WAAA;EACA,eAAA;AALN;AAQI;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AANN;AASI;EACE,cAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;AAPN;AASM;EACE,cAAA;EACA,0BAAA;AAPR;AAUM;EACE,cAAA;AARR;;AAeA;EACE;IACE,WAAA;IACA,eAAA;IACA,eAAA;IACA,mBAAA;EAZF;EAcE;IACE,yBAAA;EAZJ;EAeE;IACE,kBAAA;EAbJ;AACF;AAkBE;;;EAGE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAhBJ;AAmBE;;;;;;EAME,yBAAA;AAjBJ;AAoBE;EACE,yBAAA;AAlBJ;AAqBE;EACE,yBAAA;AAnBJ","sourcesContent":[".thank-you-dialog {\n  width: 100%;\n  max-width: 500px;\n  min-width: 400px;\n  padding: 0;\n  box-sizing: border-box;\n  background: #ffffff;\n  border-radius: 22px;\n  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35);\n  overflow: hidden;\n\n  .dialog-header {\n    display: flex;\n    justify-content: flex-end;\n    padding: 20px 24px 0 24px;\n    background: #ffffff;\n    border-top-left-radius: 22px;\n    border-top-right-radius: 22px;\n\n    .close-button {\n      color: #666;\n    }\n  }\n\n  .dialog-content {\n    padding: 32px 24px;\n    text-align: center;\n\n    .icon-container {\n      margin-bottom: 20px;\n\n      .thank-you-icon {\n        font-size: 64px;\n        width: 64px;\n        height: 64px;\n        color: #e91e63;\n      }\n    }\n\n    h2 {\n      margin: 0 0 12px 0;\n      font-size: 24px;\n      color: #333;\n    }\n\n    p {\n      margin: 0 0 8px 0;\n      color: #666;\n      font-size: 14px;\n      line-height: 1.5;\n    }\n\n    .sub-text {\n      color: #999;\n      font-size: 13px;\n    }\n\n    .comment-encouragement {\n      margin: 16px 0 0 0;\n      color: #666;\n      font-size: 14px;\n      line-height: 1.5;\n    }\n\n    .comment-link {\n      color: #e91e63;\n      text-decoration: none;\n      cursor: pointer;\n      font-weight: 500;\n      transition: color 0.2s ease;\n\n      &:hover {\n        color: #c2185b;\n        text-decoration: underline;\n      }\n\n      &:active {\n        color: #ad1457;\n      }\n    }\n  }\n}\n\n// Mobile responsiveness for Thank You dialog\n@media (max-width: 640px) {\n  .thank-you-dialog {\n    width: 100%;\n    max-width: 100%;\n    min-width: auto;\n    border-radius: 16px;\n\n    .dialog-header {\n      padding: 16px 16px 0 16px;\n    }\n\n    .dialog-content {\n      padding: 24px 16px;\n    }\n  }\n}\n\n:host-context(body.theme-dark) {\n  .thank-you-dialog,\n  .thank-you-dialog .dialog-header,\n  .thank-you-dialog .dialog-content {\n    background: #111827 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .thank-you-dialog h2,\n  .thank-you-dialog p,\n  .thank-you-dialog .sub-text,\n  .thank-you-dialog .comment-encouragement,\n  .thank-you-dialog .close-button,\n  .thank-you-dialog .close-button mat-icon {\n    color: #e2e8f0 !important;\n  }\n\n  .thank-you-dialog .comment-link {\n    color: #93c5fd !important;\n  }\n\n  .thank-you-dialog .comment-link:hover {\n    color: #bfdbfe !important;\n  }\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
